<h1 mat-dialog-title>Edit Appointment</h1>
<mat-dialog-content>
  <app-appointment-edit-form
    [appointment]="data.appointment"
    [appointmentTypes]="data.appointmentTypes"
    (saved)="onSaved($event)"
    (cancelled)="close()">
  </app-appointment-edit-form>
</mat-dialog-content>
<mat-dialog-actions class="mx-3 mb-2">
  @if (canViewNotificationLog) {
    <button mat-button (click)="viewNotifications()" [disabled]="isSaving">Notification Log</button>
  }
  <span class="flex-grow-1"></span>
  <button mat-button (click)="close()" [disabled]="isSaving">Cancel</button>
  <button mat-flat-button color="primary" (click)="triggerSave()" [disabled]="isSaving">Save</button>
</mat-dialog-actions>
